export default __webpack_public_path__ + "static/media/ios.04d51718.svg";